import type { VFC } from 'react';
import type { PopulatedSerializedCreditInvoice } from 'lib/services';
import { Modal } from 'components';
import { useCreateCreditInvoice } from '../hooks/useCreateCreditInvoice';
import { useUpdateCreditInvoice } from '../hooks/useUpdateCreditInvoice';
import { CreditInvoiceForm, RESELLERS_CREDIT_INVOICES_FORM_ID } from './Form';

interface ResellerCreditsModalProps {
  readonly onHide?: () => void;
  creditInvoice?: PopulatedSerializedCreditInvoice;
}

export const ResellerCreditsModal: VFC<ResellerCreditsModalProps> = ({ onHide, creditInvoice }) => {
  const { isLoading: isUpdating } = useUpdateCreditInvoice();
  const { isLoading: isCreating } = useCreateCreditInvoice();

  return (
    <Modal
      centered
      destroyOnClose
      open
      confirmLoading={isUpdating || isCreating}
      okButtonProps={{ form: RESELLERS_CREDIT_INVOICES_FORM_ID, htmlType: 'submit' }}
      title={creditInvoice ? 'Edit credit invoice' : 'Add credit invoice'}
      width={550}
      onCancel={onHide}
    >
      <CreditInvoiceForm creditInvoice={creditInvoice} onSubmitted={onHide} />
    </Modal>
  );
};
